// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"135":"2d53b3ac","184":"20b30b58","317":"1d2c730c","469":"0c2e4eaa","542":"5b6b42fb","626":"53dfe5d5","657":"4a7e25c1","672":"4d815961","765":"dd88253e"}[chunkId] + ".chunk.js";
};